// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB-mcQo1AEdzy1w_TjQ8vHlVv0oUitJ_xM",
  authDomain: "agroeira-5616b.firebaseapp.com",
  projectId: "agroeira-5616b",
  storageBucket: "agroeira-5616b.appspot.com",
  messagingSenderId: "425016402046",
  appId: "1:425016402046:web:44312f1818c6357ccf782f",
  measurementId: "G-55F9JGJMJF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);